// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pU5w","productName":"Table_productName__2-non"};